import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/checkout";
import { Star } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <section className="relative bg-black py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Leitores verificados</span>
          </div>
          <h2 className="font-display font-black leading-[0.95] tracking-[-0.02em] text-4xl md:text-6xl text-neutral-50">
            O que os leitores{" "}
            <span className="text-red-600 italic">estão dizendo</span>.
          </h2>
        </div>

        {loading ? (
          <div className="font-mono text-[12px] tracking-[0.25em] uppercase text-neutral-500">
            Carregando…
          </div>
        ) : items.length === 0 ? (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative border border-white/10 bg-[#0a0a0a] p-10 md:p-16 overflow-hidden"
          >
            <div className="absolute top-5 right-5 text-red-600 font-mono text-[10px] tracking-[0.3em]">
              EMPTY · RESERVED
            </div>
            <div className="font-display italic text-neutral-500 text-2xl md:text-3xl leading-snug max-w-2xl">
              "As avaliações dos leitores aparecerão aqui após as primeiras compras."
            </div>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-600 mt-6">
              Nenhum depoimento fabricado · publicação ética
            </div>
          </motion.div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {items.map((t, i) => (
              <motion.article
                key={t.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="border border-white/10 bg-[#0a0a0a] p-7"
              >
                <div className="flex gap-1 mb-4 text-red-500">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <p className="font-display italic text-neutral-200 text-lg leading-snug">
                  "{t.text}"
                </p>
                <div className="mt-5 font-mono text-[11px] tracking-[0.2em] uppercase text-neutral-500">
                  — {t.author}{t.role ? ` · ${t.role}` : ""}
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
